<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-titlec" id="lev_09">Chronology of the Trastamara and Habsburg Eras</h2>
<table>
<tbody><tr>
<td class="tab01">1492</td>
<td class="tab01">Jan</td>
<td class="tab01">Castile conquered the Kingdom of Granada, ending Muslim rule over their last part of the Iberian Peninsula.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">Oct</td>
<td class="tab01">Discovery of America by Columbus.</td>
</tr>
<tr>
<td class="tab01">1493</td>
<td class="tab01">Pope</td>
<td class="tab01">Alexander VI, in the bull ‘Inter Caetera’, awarded to Castile all the territories located more than 90 leagues west of the Cape Verde Islands.</td>
</tr>
<tr>
<td class="tab01">1494</td>
<td class="tab01"></td>
<td class="tab01">By the Treaty of Tordesillas, Castile and Portugal agreed to advance the line of demarcation between the two Crowns to 370 leagues west of Cape Verde, thus allowing Portugal to occupy what became Brazil.</td>
</tr>
<tr>
<td class="tab01">1506</td>
<td class="tab01">Nov</td>
<td class="tab01">Felipe I became co-ruler of Castile with his wife (of the House of Trastamara) Juana.</td>
</tr>
<tr>
<td class="tab01">1516</td>
<td class="tab01">23 Jan</td>
<td class="tab01">Carlos I (son of Felipe I and Juana) became King of both Aragon and Castile. His mother Juana remained nominally Queen of both realms until her death on 11 April 1555.</td>
</tr>
<tr>
<td class="tab01">1521</td>
<td class="tab01"></td>
<td class="tab01">Fernando de Magallanes, a Portuguese in the service of Castile, discovered the Philippine Islands; following his death in 1521, Juan Sebastián Elcano continued his journey to the west, arriving back in Spain in 1525, thus making the first circumnavigation of the world</td>
</tr>
<tr>
<td class="tab01">1556</td>
<td class="tab01">16 Jan</td>
<td class="tab01">Abdication of Carlos I (who died 21 Sept 1558), and accession of his son, Felipe II.</td>
</tr>
<tr>
<td class="tab01">1568</td>
<td class="tab01">23 Sept</td>
<td class="tab01">Battle of San Juan de Ulúa (Veracruz).</td>
</tr>
<tr>
<td class="tab01">1571</td>
<td class="tab01">7 Oct</td>
<td class="tab01">Battle of Lepanto – the fleets of the Holy League (the Pope, Spain and Italian States) defeat the forces of the Ottoman Empire.</td>
</tr>
<tr>
<td class="tab01">1581</td>
<td class="tab01"></td>
<td class="tab01">Declaration of Independence by the seven northern Dutch provinces.</td>
</tr>
<tr>
<td class="tab01">1582</td>
<td class="tab01">26 July</td>
<td class="tab01">Battle of Terceira (Azores) saw Spanish under Álvaro de Bazán defeat an allied (Portuguese/French/Dutch/English) fleet, thus solidifying Spanish control of Portugal.</td>
</tr>
<tr>
<td class="tab01">1588</td>
<td class="tab01"></td>
<td class="tab01">Birth of the Republic of the United Provinces.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">8 Aug</td>
<td class="tab01">Battle of Gravelines (deciding action in struggle against the Spanish ‘Felicísima Armada’).</td>
</tr>
<tr>
<td class="tab01">1589</td>
<td class="tab01"></td>
<td class="tab01">The attack by Sir Francis Drake and Sir John Norreys on Lisbon and La Coruña – known in Spain as <em class="italic">la Contraarmada.</em></td>
</tr>
<tr>
<td class="tab01">1597</td>
<td class="tab01">Sept</td>
<td class="tab01">Battle of Flores (Azores) – loss of Richard Grenville’s <em class="italic">Revenge.</em></td>
</tr>
<tr>
<td class="tab01">1598</td>
<td class="tab01">13 Sept</td>
<td class="tab01">Death of Felipe II, and accession of his son, Felipe III.</td>
</tr>
<tr>
<td class="tab01">1604</td>
<td class="tab01">28 Aug</td>
<td class="tab01">Treaty of London ended the twenty years of Anglo- Spanish War.</td>
</tr>
<tr>
<td class="tab01">1607</td>
<td class="tab01">25 Apr</td>
<td class="tab01">Battle of Gibraltar.</td>
</tr>
<tr>
<td class="tab01">1609</td>
<td class="tab01"></td>
<td class="tab01">Commencement of the Twelve Years Truce between Spain and the United Provinces.</td>
</tr>
<tr>
<td class="tab01">1621</td>
<td class="tab01">31 Mar</td>
<td class="tab01">Death of Felipe III, and accession of his son, Felipe IV.</td>
</tr>
<tr>
<td class="tab01">1622</td>
<td class="tab01"></td>
<td class="tab01">Battle of Fuengirola.</td>
</tr>
<tr>
<td class="tab01">1628</td>
<td class="tab01">8 Sept</td>
<td class="tab01">Battle of Matanzas Bay.</td>
</tr>
<tr>
<td class="tab01">1635</td>
<td class="tab01"></td>
<td class="tab01">Start of the Franco-Spanish War of 1635.</td>
</tr>
<tr>
<td class="tab01">1638</td>
<td class="tab01">22 Aug</td>
<td class="tab01">Battle of Getaria.</td>
</tr>
<tr>
<td class="tab01">1639</td>
<td class="tab01">21 Oct</td>
<td class="tab01">Battle of the Downs (-23 Oct).</td>
</tr>
<tr>
<td class="tab01">1646</td>
<td class="tab01">14 June</td>
<td class="tab01">Battle of Orbitello.</td>
</tr>
<tr>
<td class="tab01">1647</td>
<td class="tab01">21 Dec</td>
<td class="tab01">Battle of Castellamare.</td>
</tr>
<tr>
<td class="tab01">1648</td>
<td class="tab01"></td>
<td class="tab01">Peace of Munster marked the end of the Eighty Years War.</td>
</tr>
<tr>
<td class="tab01"><a id="page_16"></a>1659</td>
<td class="tab01">7 Nov</td>
<td class="tab01">Treaty of the Pyrenees ended the Franco-Spanish War of 1635.</td>
</tr>
<tr>
<td class="tab01">1665</td>
<td class="tab01">17 Sept</td>
<td class="tab01">Death of Felipe IV, and accession of his son, Carlos II.</td>
</tr>
<tr>
<td class="tab01">1667</td>
<td class="tab01"></td>
<td class="tab01">Start of the War of Devolution against France.</td>
</tr>
<tr>
<td class="tab01">1668</td>
<td class="tab01">2 May</td>
<td class="tab01">Treaty of Aix-la-Chapelle ended the War of Devolution.</td>
</tr>
<tr>
<td class="tab01">1675</td>
<td class="tab01">2 Jan</td>
<td class="tab01">Battle of Pharo (off Messina). 11 Feb Battle of Stromboli (the Lipari or Aeolian Islands).</td>
</tr>
<tr>
<td class="tab01">1676</td>
<td class="tab01">8 Jan</td>
<td class="tab01">Battle of Alicudi (also in the Lipari Islands).</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">22 Apr</td>
<td class="tab01">Battle of Augusta (Agosta).</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">3 June</td>
<td class="tab01">Battle of Palermo. Seville naval base transferred to Cádiz.</td>
</tr>
<tr>
<td class="tab01">1678</td>
<td class="tab01">17 Sept</td>
<td class="tab01">Peace of Nijmegen ended the Franco-Dutch War.</td>
</tr>
<tr>
<td class="tab01">1682</td>
<td class="tab01"></td>
<td class="tab01">Start of War of the Reunions.</td>
</tr>
<tr>
<td class="tab01">1684</td>
<td class="tab01">13 Aug</td>
<td class="tab01">Close of the War of the Reunions.</td>
</tr>
<tr>
<td class="tab01">1688</td>
<td class="tab01"></td>
<td class="tab01">Start of the Nine Years War.</td>
</tr>
<tr>
<td class="tab01">1692</td>
<td class="tab01">5 Aug</td>
<td class="tab01">Action off La Coruña.</td>
</tr>
<tr>
<td class="tab01">1697</td>
<td class="tab01">20 Sept</td>
<td class="tab01">Treaty of Ryswick ended the Nine Years War.</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Chronology.vue?7adaeb86